import { render, staticRenderFns } from "./ReleasePreviewChanges.vue?vue&type=template&id=407dcb52&scoped=true&"
import script from "./ReleasePreviewChanges.vue?vue&type=script&lang=js&"
export * from "./ReleasePreviewChanges.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePreviewChanges.vue?vue&type=style&index=0&id=407dcb52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407dcb52",
  null
  
)

export default component.exports